import styled from 'styled-components';

export const StyledEmployeeDataCostElement = styled.form`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;

    > div {
        &:first-child {
            width: calc(100% - 54px);
        }
    }
`;
